module.exports = __webpack_public_path__ + "static/media/job_agile42.8a687dd0.jpg";